import React, { useEffect, useState } from "react";
import ShimmerLoader from "../../../../components/ShimmerLoader";
import styles from "./ChangeRequest.module.css";
import { _ToNormal, setDate } from "../../../../Utils/helper";
import { useNavigate, useParams } from "react-router-dom";
import API from "../../../../ApiConfig";
import {
  BASE_URL,
  GET_APPEAL_METADATA_ISSUER,
  SET_APPEAL_STATUS,
  USER_TOKEN,
} from "../../../../Utils/constant";
import cogoToast from "cogo-toast-react-17-fix";
import useRefreshToken from "../../../../Hooks/usegenerateToken";
import ReactPortalModal from "../../../../components/ReactPortalModal";
import Icon from "react-icons-kit";
import{check} from "react-icons-kit/feather/check"
import { pencil } from "react-icons-kit/icomoon/pencil";
import {x} from "react-icons-kit/feather/x";
import { useSelector } from "react-redux";
import { androidArrowBack } from "react-icons-kit/ionicons/androidArrowBack";

const DocumentDiscrepencyDetails = () => {
  useRefreshToken(BASE_URL + USER_TOKEN);
  const [action, setAction] = useState("");
  const [issueNewDoc, setIssuerNewDoc] = useState(false);

  const [showRemarksBox, setshowRemarkBox] = useState(false);
  const [remarks, setRemark] = useState("");
  const navigate = useNavigate();
  const { appeal_id } = useParams();

  const [loading, setLoading] = useState(false);
  const [metaData, setMetaData] = useState(null);

  const [preview, setPreview] = useState("");
  const data = {
    id: 1,
    verifier_name: "John Doe",
    appeal_remarks: "Hiii",
    Email: "john@example.com",
    raised_on: "02-02-1999",
    appeal_status: "Pending",
    request_id: "1",
    discrepency_fields: [
      {
        field_id: 1,
        field_name: "first_name",
        original_value: "Jack",
        verifier_raised_value: "Jack King",
      },
      {
        field_id: 2,
        field_name: "date_of_leaving",
        original_value: "02-02-2015",
        verifier_raised_value: "02-02-2019",
      },
      {
        field_id: 3,
        field_name: "emp_id",
        original_value: "EMP123",
        verifier_raised_value: "EMP234",
      },
    ],
  };
  const USER=useSelector(state=>state.User)
  useEffect(() => {
    getappealMetaData();
  }, []);
  const getappealMetaData = () => {
    setLoading(true);
    API.get(GET_APPEAL_METADATA_ISSUER + appeal_id)
      .then((res) => {
        if (res.data.status === 201) {
          setLoading(false);
          setMetaData(res.data.data);
        } else {
          setLoading(false);
          cogoToast.error("Error while getting data");
        }
      })
      .catch((err) => {
        setLoading(false);
        cogoToast.error(err.response.data.detail[0]);
      });
  };
  const setAppeal = (apiData) => {
    setLoading(true);
    API.post(SET_APPEAL_STATUS, apiData)
      .then((res) => {
        if (res.data.status == 200) {
          const route=USER.user_type=="Super Admin"?"/appeals":"/dashboard/DocAppeals"
          navigate(route);
          setLoading(false);
        } else {
          cogoToast.error("Some Error Occurred");
        }
      })
      .catch((err) => {
        setLoading(false);
        cogoToast.error(err.response?.data?.message);
      });
  };
  const [newValue, setNewValue] = useState([]);
  useEffect(() => {
    if (metaData && metaData.fields) {
      setNewValue(
        metaData.fields.map((field) => ({
          ...field,
          noneValue: "",
          changed_value: field.value ? field.value : "",
        }))
      );
    }
  }, [metaData]);
  const isAnyFieldNone = newValue.some((field) => field.noneValue === true);
    
  const handleAction = (actionType, id) => {
    setNewValue((prev) =>
      prev.map((field) => {
        if (field.id !== id) return field;
  
        // Reset all states first
        let updated = { ...field, checked: false, noneValue: false, rejected: false };
  
        if (actionType === "modify") {
          updated.noneValue = true;
          updated.changed_value = "";
        } else if (actionType === "reject") {
          updated.rejected = true;
          updated.changed_value = "";
        }
  
        return updated;
      })
    );
  }
  const handleInput = (e, id) => {
    setNewValue((prev) =>
      prev.map((field) =>
        field.id === id
          ? {
              ...field,
              changed_value: e.target.value,
            }
          : field
      )
    );
  };
  const handleAcceptRejectState = (state) => {
    if (!remarks.trim()) {
      cogoToast.error("Please provide remarks before submitting.");
      return;
    }
  
    setAction(state);
    const issuer_payload = {};
    let isValid = true;
  
    if (state === "accept") {
      //Accepting all verified values
      for (let item of newValue) {
        if (item.checked) {
          issuer_payload[item.id] = item.verifier_value;
        } else if (item.noneValue && item.changed_value) {
          issuer_payload[item.id] = item.changed_value;
        } else if (item.rejected) {
          issuer_payload[item.id] = null;
        }
      }
  
      if (!isValid) return;
  
      const apiData = {
        appeal_id: appeal_id,
        status: 2, // Accepted
        issuer_payload,
        issuer_remarks: remarks,
      };
  
      setAppeal(apiData);
    }
  
    //Some fields modified or rejected
    else if (state === "none") {
      for (let item of newValue) {
        // Require value for modified fields
        if (item.noneValue && item.changed_value === "") {
          isValid = false;
          cogoToast.error(
            `Please enter the new value for ${_ToNormal(item.field_name)}`
          );
          break;
        }
  
        //Safe Regex validation
        if (item.changed_value && item.regex) {
          try {
            const pattern = new RegExp(item.regex);
            if (!pattern.test(item.changed_value)) {
              isValid = false;
              cogoToast.error(
                `The value entered for "${_ToNormal(item.field_name)}" is not in the correct format. Please check and try again.`
              );
            }
          } catch (error) {
            console.error("Invalid regex pattern:", item.regex, error);
            isValid = false;
            cogoToast.error(
              `Unable to validate "${_ToNormal(item.field_name)}" at the moment. Please try again.`
            );
          }
        }
  
        // Build payload per field type
        if (item.noneValue && item.changed_value) {
    issuer_payload[item.id] = item.changed_value;

  //Include if it's accepted (checked true)
  } else if (item.checked && !item.rejected) {
    issuer_payload[item.id] = item.verifier_value;
  }
      }
  
      if (!isValid) return;
  
      const apiData = {
        appeal_id: appeal_id,
        status: 4, // Modified / Partial
        issuer_payload,
        issuer_remarks: remarks,
      };
  
      console.log("Final Payload (Modify):", apiData);
      setAppeal(apiData);
    }
  
    //Entire appeal rejected
    else if (state === "reject") {
      const apiData = {
        appeal_id: appeal_id,
        status: 3,
        issuer_remarks: remarks,
      };
      console.log("Final Payload (Reject):", apiData);
      setAppeal(apiData);
      setIssuerNewDoc(false);
      setshowRemarkBox(true);
    }
  };

  const handleCheckBox = (checked, id, value) => {
    setNewValue((prev) =>
      prev.map((field) =>
        field.id === id
          ? {
              ...field,
              checked: checked,
              changed_value: checked ? value : "",
              noneValue: false,
              rejected: false,
            }
          : field
      )
    );
  };


  const DocPreview = () => {
    var loading = {
        padding: "1rem",
        height: "10vh",
        width: "-webkit-fill-available",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
    if (!preview) {
        return (<div style={loading}>
            Loading Pdf ...
        </div>)
    }
    else {
        return (
            <embed
                id="pdf-viewer"
                src={preview + "#toolbar=0"}
                type="application/pdf"
            />
        )
    }
}

  return (
    <div style={{width:"100%"}}>
      <div>
        <h2>
        <Icon icon={androidArrowBack} size={'25'} onClick={() => navigate(-1)} style={{ cursor: 'pointer', paddingRight:"7px" }} /> Change Request Review
        </h2>
        <span className="secondaryButton1" style={{color:"gray"}}>Review and approve employee data modifications</span>
        <div className={styles.DiscrepencyRecords}>
          {loading?<div className="shimmer" style={{width:"50%", height:"15rem"}}></div>:
          <table style={{width: "50%", border:"1px solid lightgray", borderRadius:"10px", padding:"15px", backgroundColor:"white",boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}>
            <tbody>
              <>
                <tr>
                  <td
                    style={{
                      padding: "11px",
                      fontSize:"16px",
                      fontWeight: "500",
                      width: "5rem",
                    }}
                  >
                    Candidate Name
                  </td>
                  <td style={{ padding: "11px", fontSize:"16px" }}>
                    {metaData?.name}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "11px",
                      fontSize:"16px",
                      fontWeight: "500",
                    }}
                  >
                    Candidate Email
                  </td>
                  <td style={{ padding: "11px", fontSize:"16px" }}>
                    {metaData?.email ?metaData?.email:"NA"}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "11px",
                      fontSize:"16px",
                      fontWeight: "500",
                    }}
                  >
                    Candidate No
                  </td>
                  <td style={{ padding: "11px", fontSize:"16px" }}>
                    {metaData?.phone_number ?metaData?.phone_number:"NA"}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "11px",
                      fontSize:"16px",
                      fontWeight: "500",
                    }}
                  >
                    Raised On
                  </td>
                  <td style={{ padding: "11px", fontSize:"16px" }}>
                    {setDate(metaData?.appeal_raised_on? metaData?.appeal_raised_on:"NA")}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "11px",
                      fontSize:"16px",
                      fontWeight: "500",
                    }}
                  >
                    Appeal Status
                  </td>
                  <td
                    className={loading?null:metaData?.status=="APPROVED"?"Complete":metaData?.status=="DENIED"?"Rejected":"Pending"}
                    style={{ padding: "11px", fontSize:"16px" }}
                  >
                    {_ToNormal(metaData?.status)}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "11px",
                      fontSize:"16px",
                      fontWeight: "500",
                    }}
                  >
                    Supporting Document
                  </td>
                  <td
                    style={{

                      padding: "11px",
                      fontSize:"16px",
                      fontWeight: "500",
                    }}
                  >
                    <button className="btn btn-secondary" onClick={(e) =>setPreview(metaData?.full_pdf ? metaData?.full_pdf : null)}

                      style={{
                        display: "flex",
                        gap: "0.3rem",
                        fontSize:"16px",
                        textDecoration: "none",
                      }}
                    >
                      <img
                        className={styles.downloadOutlineIcon}
                        alt=""
                        src="/downloadoutline.svg"
                      />
                      View pdf
                    </button>
                  </td>
                </tr>
              </>
            </tbody>
          </table>}
        </div>
        {/* <div className={styles.IssueBtn}>
          <button
            className={`btn btn-primary ${!issueNewDoc ? styles.hide : null} `}
            onClick={() => navigate("/dashboard/credentials/issue-credentials")}
          >
            Issue Credentials
          </button>
        </div> */}
        <div className="credentials-table">
          <table style={{ border:"1px solid lightgray", borderRadius: "10px", padding:"0px 15px", backgroundColor:"white" }}>
            <tr className="credentials-header" style={{border:"0"}}>
              <th className="credentials-th">
                <div className="credentials-table-text" style={{color:"black", fontWeight:"700", fontSize:"18px"}}>Field Label</div>
              </th>
              <th className="credentials-th">
                <div className="credentials-table-text" style={{color:"black", fontWeight:"700", fontSize:"18px"}}>Original Value</div>
              </th>

              <th className="credentials-th">
                <div className="credentials-table-text" style={{color:"black", fontWeight:"700", fontSize:"18px"}}>Change Requested</div>
              </th>
            {metaData?.status!=="APPROVED" && metaData?.status!=="ISSUER_ADDED_DIFFERENT_VALUE" && metaData?.status!=="DENIED"&& <th className="credentials-th justify-content-center">
                <div className="credentials-table-text" style={{color:"black", fontWeight:"700", fontSize:"18px"}}>Action</div>
              </th>}
              <th className="credentials-th">
                <div className="credentials-table-text" style={{color:"black", fontWeight:"700", fontSize:"18px"}}>Status</div>
              </th>
              <th className="credentials-th justify-content-center">
                <div className="credentials-table-text" style={{color:"black", fontWeight:"700", fontSize:"18px"}}>New Value</div>
              </th>
              {/* <th className="credentials-th justify-content-center">
                      <div className="credentials-table-text">Remarks</div>
                    </th> */}
            </tr>
            {loading ? (
              <>
                <tr className="credentials-tr">
                  <td className="credentials-td">
                    <div className="credentials-table-text">
                      {" "}
                      <ShimmerLoader width="10rem" height="1.5rem" />
                    </div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text">
                      <ShimmerLoader width="7rem" height="1.5rem" />
                    </div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text">
                      {" "}
                      <ShimmerLoader width="7rem" height="1.5rem" />
                    </div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text">
                      {" "}
                      <ShimmerLoader width="7rem" height="1.5rem" />
                    </div>
                  </td>
                </tr>
                <tr className="credentials-tr">
                  <td className="credentials-td">
                    <div className="credentials-table-text">
                      {" "}
                      <ShimmerLoader width="10rem" height="1.5rem" />
                    </div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text">
                      <ShimmerLoader width="7rem" height="1.5rem" />
                    </div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text">
                      {" "}
                      <ShimmerLoader width="7rem" height="1.5rem" />
                    </div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text">
                      {" "}
                      <ShimmerLoader width="7rem" height="1.5rem" />
                    </div>
                  </td>
                </tr>
              </>
            ) : (
              <>
                {newValue.map((i, index) => {
                  return (
                    <tr
                      className="credentials-tr"
                      style={{ animationDelay: `${index * 0.1}s`, backgroundColor:i.verifier_value?"rgb(240, 240, 240)":"",margin:"10px 0px", border:"1px solid lightgray", borderRadius:"10px"}}
                    >
                      <td className="credentials-td">
                        <div className="credentials-table-text1" style={{fontSize:"16px"}}>
                          {_ToNormal(i.field_name)}
                        </div>
                      </td>
                      <td className="credentials-td">
                        <div className="credentials-table-text1" style={{fontSize:"16px"}}>
                          <div style={{fontStyle:"16px", textAlign:"center"}}>{i.original_value}</div>
                        </div>
                      </td>
                      <td className="credentials-td">
                        <div className="credentials-table-text1" style={{textAlign:"center"}}>
                          <div className={styles.OriginalValue}>
                            {i.verifier_value}
                            {/* {i.verifier_value && (
                            metaData.status !== "APPROVED" && metaData.status !== "ISSUER_ADDED_DIFFERENT_VALUE" && metaData.status!=="DENIED"&&  <div class="checkbox-wrapper-18">
                                <input
                                  type="checkbox"
                                  checked={i.checked}
                                  onChange={(e) =>
                                    handleCheckBox(
                                      e.target.checked,
                                      i.id,
                                      i.verifier_value
                                    )
                                  }
                                />
                              </div>
                            )} */}
                          </div>
                        </div>
                      </td>
                    {metaData.status!=="APPROVED" && metaData.status!=="ISSUER_ADDED_DIFFERENT_VALUE" && metaData.status!=="DENIED" &&  <td className="credentials-td">
                        <div className="credentials-table-text1">
                      
  {i.value &&
                        <div style={{ display: "flex", gap: "6px" }}>
  {/* ✅ Accept */}
  <div
    className={`${styles.ActionBtn} ${i.checked ? styles.accept : ""}`}
    onClick={() => handleCheckBox(!i.checked, i.id, i.verifier_value)}
  >
    <Icon icon={check} size={16} />
  </div>

  {/* ✏️ Modify */}
  <div
    className={`${styles.ActionBtn} ${i.noneValue ? styles.none : ""}`}
    onClick={() => handleAction("modify", i.id)}
  >
    <Icon icon={pencil} size={16} />
  </div>

  {/* ❌ Reject */}
  <div
    className={`${styles.ActionBtn} ${i.rejected ? styles.reject : ""}`}
    onClick={() => handleAction("reject", i.id)}
  >
    <Icon icon={x} size={16} />
  </div>
</div>}
                        </div>
                      </td>}
                      <td className="credentials-td">
                        <div className="credentials-table-text1">
                        {i.value&&
                          <div
                          className={styles.appealBadge}
                          style={{
                            color:
                              i.rejected
                                ? "red"
                                : i.verifier_value === i.value && !i.noneValue
                                ? "green"
                                : i.noneValue
                                ? "rgb(238, 170, 44)"
                                : metaData.status === "DENIED"
                                ? "gray"
                                : "rgb(238, 170, 44)",
                            fontSize: "16px",
                          }}
                        >
                          {i.rejected
                            ? "Reject"
                            : i.verifier_value === i.value && !i.noneValue
                            ? "Accept"
                            : i.noneValue
                            ? "Modify"
                            : metaData.status === "DENIED"
                            ? "No Change"
                            :i.original_value== i.changed_value?
                            "Original Value Accepted"
                            : "Modify"}
                        </div>
                        }
                        </div>
                      </td>
                      <td className="credentials-td">
                        {i.value && (
                          <div className="credentials-table-text1">
                            <input
                              type="text"
                              className={styles.input}
                              value={i.changed_value}
                              style={{fontSize:"16px"}}
                              onChange={(e) => handleInput(e, i.id)}
                              disabled={!i.noneValue}
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </>
            )}
          </table>
      {metaData?.status!=="APPROVED" && metaData?.status!=="ISSUER_ADDED_DIFFERENT_VALUE" && metaData?.status!=="DENIED"&& <div className="credentials-table">
      <div className={styles.ActionContainer}>
      {loading?<div className="shimmer" style={{width:"100%", height:"10rem"}}></div>:
      <>
        <label style={{margin:"10px 0px"}}>Reason for Decision <span style={{color:"red"}}>*</span></label>
                <textarea
                  className={styles.input}
                  style={{width:"inherit",padding: "10px", height:"7rem", resize:"none", overflowX:"auto", fontSize:"16px", backgroundColor:"rgb(241, 241, 241)" }}
                  placeholder="Please provide a detailed reason for your decision"
                  onChange={(e) => setRemark(e.target.value)}
                />
              </>}
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
  {newValue.some((item) => item.noneValue || item.rejected) && (
    <button
      className="btn btn-primary"
      style={{
        margin: "1rem 0",
        fontSize: "16px",
        fontWeight: "700",
      }}
      onClick={() =>{ const verifierFields = newValue.filter((item) => item.verifier_value);
        
        // ✅ Check if all such fields are rejected
        const allRejected = verifierFields.length > 0 && verifierFields.every((item) => item.rejected);
        handleAcceptRejectState(allRejected ? "reject" : "none")}
      }
    >
      Submit Reason
    </button>
  )}
</div>
              {loading?"":
          newValue.some((item) => item.noneValue || item.rejected)?null:  <div className={styles.Actions}>
              <button
                className={`btn  ${styles.accept}`}
                onClick={() => handleAcceptRejectState("accept")}
                disabled={isAnyFieldNone}
              >
                Accept All Changes
              </button>
              <button
                className={`btn ${styles.reject}`}
                onClick={() => handleAcceptRejectState("reject")}
                disabled={isAnyFieldNone}
              >
                Reject All Changes
              </button>
            </div>}
          </div>}
        </div>
      </div>
      <ReactPortalModal title={"Supporting Document"} isOpen={preview} onClose={(e)=>setPreview(null)}>
        <DocPreview/>
      </ReactPortalModal>
    </div>
  );
};

export default DocumentDiscrepencyDetails;
